import React from 'react';

export default function DigitalProgress(props) {
  const {color} = props;

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="29.725"
      height="29.724"
      viewBox="0 0 29.725 29.724"
    >
      <g
        fill="none"
        stroke={color}
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1"
        data-name="Group 37"
        transform="translate(.5 .5)"
      >
        <path
          d="M7.377 21.698l-4.82-5.185a1.6 1.6 0 112.337-2.173l6.81 7.6v6.782H6.383v-4.256L0 17.551v-11.7a1.064 1.064 0 012.128 0v9.575"
          data-name="Path 3944"
        ></path>
        <path
          d="M21.349 21.698l4.82-5.185a1.6 1.6 0 10-2.337-2.173l-6.81 7.6v6.782h5.319v-4.256l6.383-6.915v-11.7a1.064 1.064 0 00-2.128 0v9.575"
          data-name="Path 3945"
        ></path>
        <ellipse
          cx="5.851"
          cy="5.851"
          data-name="Ellipse 83"
          rx="5.851"
          ry="5.851"
          transform="translate(8.511)"
        ></ellipse>
        <path d="M11.703 0L0 0" data-name="Line 54" transform="translate(8.511 5.851)"></path>
        <ellipse
          cx="3.192"
          cy="5.851"
          data-name="Ellipse 84"
          rx="3.192"
          ry="5.851"
          transform="translate(11.171)"
        ></ellipse>
        <path d="M0 11.703L0 0" data-name="Line 55" transform="translate(14.362)"></path>
      </g>
    </svg>
  );
}
